export class MathUtil {
    public static sum(values: number[]): number {
        if (values.length === 0) {
            return 0;
        }

        return values.reduce((accumulator, value) => accumulator + value, 0);
    }


    public static avg(values: number[]): number {
        const total: number = MathUtil.sum(values);
        if (total === 0) {
            return 0;
        }

        return MathUtil.round(total / values.length, 2);
    }

    public static applyVariation(value: number, variation: number): number {
        let increase: number;
        if (value >= 0) {
            increase = 1 + (variation / 100);
        } else {
            increase = 1 - (variation / 100);
        }

        return value * increase;
    }

    public static median(values: number[]): number {
        if (values.length === 0) {
            return 0;
        }
        if (values.length === 1) {
            return values[0];
        }

        const valuesSorted: number[] = values.sort((a, b) => {
            return a - b;
        });

        if (valuesSorted.length % 2 === 0) {
            return MathUtil.avg([valuesSorted[(valuesSorted.length / 2) - 1], valuesSorted[(valuesSorted.length / 2)]]);
        }

        return valuesSorted[Math.floor(valuesSorted.length / 2)];
    }

    public static percentage(part: number, total: number): number {
        if (typeof part !== 'number' || typeof total !== 'number') {
            return undefined;
        }

        if (total === 0) {
            return 0;
        }

        return ((part / total) * 100);
    }

    public static round(value: number, decimals: number): number {
        if (typeof value !== 'number') {
            return value;
        }

        if (decimals === 0) {
            return Math.round(value);
        }

        return Math.round(value * (10 ** decimals)) / (10 ** decimals);
    }

    public static variation(originalValue: number, newValue: number): number {
        let percent = 0;
        if (newValue !== 0) {
            if (originalValue !== 0) {
                percent = (newValue - originalValue) / Math.abs(originalValue) * 100;
            } else {
                percent = ((newValue > 0) ? 1 : -1) * 100;
            }
        } else if (originalValue !== 0) {
            percent = ((originalValue > 0) ? 1 : -1) * -100;
        }

        return Math.floor(percent);
    }
}
